module.exports = __webpack_public_path__ + "static/media/img_flow3@2x.344c6657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_flow3@2x.png
// module id = 912
// module chunks = 0